import * as React from 'react';

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from "@mui/material/Select"




export default function CharismaAutoFillForm(props){
    
    const [type, setType] = React.useState(0);
    const [profile, setProfile] = React.useState(1);
    const [wait, setWait] = React.useState(false);
      

    function handleSubmit(){                   
        setWait(true);
        props.handleSubmit(type, profile);                    
    }
    

    
    return(
        <Dialog
            open={true}
        >
            <DialogTitle>
                {props.title !== undefined ?
                    props.title
                    :
                    null
                }
            </DialogTitle>
            <DialogContent>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Type</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={type}
                        label="Type"
                        onChange={(e)=>setType(e.target.value)}
                    >
                        <MenuItem value={0}>Bilan Mensuel</MenuItem>
                        <MenuItem value={1}>Evaluation</MenuItem>
                    </Select>
                </FormControl>                                  
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Profile</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={profile}
                        label="Profile"
                        onChange={(e)=>setProfile(e.target.value)}
                    >
                        <MenuItem value={1}>OF</MenuItem>
                        <MenuItem value={2}>Tuteur</MenuItem>
                    </Select>
                </FormControl>
                {wait ?
                    <Alert severity="info">{props.id === undefined ? "Création en cours" : "Modification en cours"}</Alert>
                    :
                    null
                }                 
            </DialogContent>
            <DialogActions>
                <Button disabled={wait} onClick={()=>handleSubmit()}>Valider</Button>
                <Button disabled={wait} onClick={()=>props.handleCancel()}>Annuler</Button>
            </DialogActions>
        </Dialog>        
    );
}